"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Submissions = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var styled_1 = __importDefault(require("@emotion/styled"));
var __1 = require("..");
var models_1 = require("../../../models");
var Button_1 = require("../Button");
var BUTTON_ITEM_CLASS_NAME = "_buttonItem";
var StyledWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  > .", " + .", " {\n    margin-top: 16px;\n  }\n\n  label: SubmissionWrapper;\n"], ["\n  text-align: center;\n  > .", " + .", " {\n    margin-top: 16px;\n  }\n\n  label: SubmissionWrapper;\n"])), BUTTON_ITEM_CLASS_NAME, BUTTON_ITEM_CLASS_NAME);
var Submissions = function (_a) {
    var submissions = _a.submissions, onPreviousButtonClick = _a.onPreviousButtonClick, onNextButtonClick = _a.onNextButtonClick, disabled = _a.disabled, design = _a.design, className = _a.className;
    var _b = design.colors, submitButtonBackground = _b.submitButtonBackground, submitButtonFont = _b.submitButtonFont;
    return ((0, jsx_runtime_1.jsx)(StyledWrapper, __assign({ className: className }, { children: submissions.map(function (button) {
            if (button.type === models_1.FORM_PAGE_BUTTON_TYPE.next) {
                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: BUTTON_ITEM_CLASS_NAME }, { children: (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ type: "button", backgroundColor: submitButtonBackground, fontColor: submitButtonFont, buttonType: button.type, disabled: disabled.next, onClick: function () {
                            if (onNextButtonClick) {
                                onNextButtonClick(button.endpoint);
                            }
                        }, css: { label: 'Submission__Next' } }, { children: button.label })) }), button.type));
            }
            if (button.type === models_1.FORM_PAGE_BUTTON_TYPE.previous) {
                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: BUTTON_ITEM_CLASS_NAME }, { children: (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ type: "button", backgroundColor: submitButtonBackground, fontColor: submitButtonFont, buttonType: button.type, disabled: disabled.previous, onClick: function () {
                            if (onPreviousButtonClick) {
                                onPreviousButtonClick(button.endpoint);
                            }
                        }, css: { label: 'Submission__Previous' } }, { children: button.label })) }), button.type));
            }
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: BUTTON_ITEM_CLASS_NAME }, { children: (0, jsx_runtime_1.jsx)(__1.LinkButton, __assign({ href: button.siteUrl, target: button.target, backgroundColor: submitButtonBackground, fontColor: submitButtonFont, buttonType: button.type, disabled: disabled.externalLink, css: { label: 'Submission__Link' } }, { children: button.label })) }), button.type));
        }) })));
};
exports.Submissions = Submissions;
var templateObject_1;
